CheckoutV2.Cart.Totals = function(checkout, cart, isReview, existing_totals) {
	var totals = this;

	this.values = existing_totals || {
		'subtotal': '0.00',
		'subtotalTaxable': '0.00',
		'origShipping': '0.00',
		'shipping': '0.00',
		'originalShippingRetail': '0.00',
		'origTax': '0.00',
		'tax': '0.00',
		'fees': {},
		'total': '0.00',
		'balances': {},
		'remaining': '0.00',
		'credits': '0.00',
	};

	this.taxRate = 0;
	this.taxValue = 0;

	if (!isReview) {
		this.$wrap = $('.section.order-total');
		this.$loadingOverlay = $('#cart-totals-overlay');
		this.$loadingMsg = this.$loadingOverlay.find('.msg-text');
		this.$subtotal = $('#cart-subtotal');
		this.$cartPromotions = $('#cart-promotions');
		this.$cartPromoSubtotal = $('#cart-promo-subtotal');
		this.$shipping = $('#cart-shipping');
		this.$shippingOverrideWrap = $('#cart-shipping-override-wrap');
		this.$shippingOverride = $('#cart-shipping-override');
		this.$sameDayNotice = $('.same-day-notice');
		this.$sameDayCutoff = $('.same-day-notice .js-cutoff-time');
		this.$taxWrap = $('#cart-tax-wrap');
		this.$tax = $('#cart-tax');
		this.$taxExemptWrap = $('#cart-tax-exempt-wrap');
		this.$taxExempt = $('#cart-tax-exempt');
		this.$totalWrap = $('#cart-total-wrap');
		this.$total = $('#cart-total');
		this.$remainingWrap = $('#cart-remaining-wrap');
		this.$remaining = $('#cart-remaining');
		this.$cartNumItems = $('#cart-num-items');
		this.$textCart = $("#textcart");
        this.$paypalCreditMessaging = $(".js-paypal-credit-messaging");
        this.$paypalExpressWrapper = $(".paypal-option");
        this.$paypalExpressCreditWrapper = $(".paypal-credit-option");
        this.$paypalExpressButton = $(".js-braintree-paypal-express-button");
        this.$paypalExpressCreditButton = $(".js-braintree-paypal-express-credit-button");
	} else {
		this.$wrap = $();
		this.$loadingOverlay = $();
		this.$loadingMsg = $();
		this.$subtotal = $();
		this.$shipping = $();
		this.$shippingOverrideWrap = $();
		this.$shippingOverride = $();
		this.$taxWrap = $();
		this.$tax = $();
		this.$taxExemptWrap = $();
		this.$taxExempt = $();
		this.$totalWrap = $();
		this.$total = $();
		this.$remainingWrap = $();
		this.$remaining = $();
		this.$cartNumItems = $();
		this.$textCart = $();
	}


	this.elementType = checkout.config.isEndeca ? 'span' : 'label';
    this.paymentButtonShown = false;
    this.paymentCreditButtonShown = false;

    // Array of functions to be fired when the total changes
    this._totalChangedListeners = [];

    this.registerTotalChangedListener = function(fn) {
        totals._totalChangedListeners.push(fn);
    };

    this.removeTotalChangedListener = function(fn) {
        totals._totalChangedListeners = totals._totalChangedListeners.filter(function(listener) {
            return listener !== fn;
        });
    };

    this._callTotalChangedListeners = function(oldValues) {
        totals._totalChangedListeners.forEach(function(fn) {
            fn(oldValues);
        });
    };

	this.init = function() {
		totals.listen();

		if (
			checkout.user
			&& checkout.session.get('taxExempt')
		)
			totals.$taxExempt.prop('checked', true);
	};

	this.listen = function() {
		totals.$taxExempt.change(totals.changeTaxExempt);
	};

	this.calc = function(force) {
		totals.updateNumItems();
		cart.shipping.calc(force);
		// load paypal checkout and paypal credit buttons, asynchronously
		totals.showPaypalExpressButton({ button: 'credit' });
		totals.showPaypalExpressButton({ button: 'checkout' });
	};

	this.updateNumItems = function() {
		var numItems = 0;

		for (var cartItemKey in cart.items)
			numItems += parseInt(cart.items[cartItemKey].data.qty);

		totals.$cartNumItems
			.html('<i class="icon-white icon-shopping-cart"></i> <b>My Cart: </b> <span class="cartCount">'+ numItems +'</span>')
			.attr('title', 'You have '+numItems+' item(s) in your cart');

		$(checkout.config.cartItemCount).text(numItems); // update the header shopping cart badge
	};

	this.update = async function(stepChanged) {
		var oldValues = $.extend(true, {}, totals.values);

		var subtotal = 0.00,
			subtotalTaxable = 0.00,
			shipping = cart.shipping.total,
			originalShippingRetail = cart.shipping.originalShippingRetail,
			tax = 0.00,
			fees = 0.00,
			remaining = 0.00,
			credits = 0.00;

		var origTax;

		for (var cartItemKey in cart.items) {
			var item = cart.items[cartItemKey];

			subtotal += (item.data.qty * item.unitprice);

			if (!parseInt(item.data.taxExempt))
				subtotalTaxable += (item.data.qty * item.unitprice);
		}

		totals.values.origShipping = shipping.toMoney();

		if (
			checkout.user
			&& checkout.session.get('shippingOverride')
		)
			shipping = (parseFloat(checkout.session.get('shippingOverrideAmt')) || 0);

		totals.values.origTax = '0.00';
		origTax = 0;

        totals.loading( "Calculating sales tax" );
        var taxCalc = () => {
            return new Promise( ( resolve, reject ) => {
                checkout.remote
                    .call( {
                        'url'  : "/taxCalc/",
                        'data' : {
                            'shippingCost' : shipping,
                            'country'      : checkout.session.get( "shipping.country" ),
                            'zip'          : checkout.session.get( "shipping.zip" ),
                            'state'        : checkout.session.get( "shipping.state" )
                        }
                    } )
                    .done( ( response ) => {
                        if ( response.salesTax !== null ) {
                            resolve( response.salesTax );
                        }
                        else {
                            reject();
                        }
                    } )
                    .fail( () => {
                        reject();
                    } );
            } );
        };
        try {
            origTax = await taxCalc();
        }
        catch ( e ) {
            console.warn( "tax calc failed", e );
        }
        totals.loading( false );

        if (
            checkout.user
            && totals.$taxExempt.prop('checked')
        )
            tax = 0.00;
        else
            tax = origTax;

        var $taxExplain = $( ".js-tax-explain" );
        $taxExplain.popover( {
            content   : "placeholder content",
            trigger   : "focus",
            placement : "right",
            title     : "",
            container : $taxExplain[ 0 ],
        } );
        var country = checkout.session.get( "shipping.country" );
        if ( country && checkout.config.countryTaxExplain[ country ] ) {
            var description = checkout.config.countryTaxExplain[ country ];

            // update popover content
            var popover = $taxExplain.data( "bs.popover" );
            if ( popover ) {
                popover.config.content = description;
                popover.setContent();
            }

            $taxExplain.show();
        }
        else {
            // no explanation to show
            $taxExplain.hide();
        }

		totals.values.origTax = origTax.toMoney();

		totals.values.subtotal = subtotal.toMoney();
		totals.values.subtotalTaxable = subtotalTaxable.toMoney();
		totals.values.shipping = shipping.toMoney();
		totals.values.originalShippingRetail = originalShippingRetail.toMoney();
		totals.values.tax = tax.toMoney();

		var taxFloat = parseFloat(totals.values.tax);//Takes tax which is a string and converts it to floating point so it can be added

		for (var feeLabel in totals.values.fees)
			fees += parseFloat(totals.values.fees[feeLabel]);
			
		totals.values.total = (
			subtotal
			+ shipping
			+ taxFloat
			+ fees
		).toMoney();

		remaining = parseFloat(totals.values.total);

		var creditLabels = [];
		if (checkout.payment.balanceMethods) {
			if (stepChanged !== 'payment') {
				checkout.payment.reApplyBalances(false); // re-calc balances if needed (ex. gift cards applied and then shipping options change)
			}
			$.each( checkout.payment.balanceMethods, function(o) { creditLabels.push(o.label) } );
		}

		for (var balanceLabel in totals.values.balances) {
			remaining -= parseFloat(totals.values.balances[balanceLabel]);
			if ($.inArray(balanceLabel, creditLabels)) {
				credits += totals.values.balances[balanceLabel]; // credits = gift cards, store credit, rewards
			}
		}

		if (remaining < 0)
			remaining = 0;

		totals.values.remaining = remaining.toMoney();
		
		totals.values.credits = credits.toMoney();

		totals.buildContent();

		var valid = cart.shipping.getValidateErrors().length > 0; //cart.validate();

		totals.loading(false, valid, stepChanged);

		if (valid) {
			//if (checkout.currentStepName() == 'cart')
			//	cart.toggleStepControls();
			//else if (!checkout.shipping)
			//	return cart.proceed();
		} else {
			if(checkout.session.get('initPaypalPayment') === 0 && checkout.session.get('initAffirmpayment') === 0){
				checkout.session.set({
					'step': 'cart'
				});
			}
		}
		
		// if (stepChanged && stepChanged != 'payment' && checkout.payment) {
		// 	checkout.payment.toggleMethodRequired();
		// }

		if (checkout.config.paypalError) {
			cart.error(checkout.paypalErrorMsg);
			checkout.config.paypalError = 0;
		}
		if (checkout.config.affirmError) {
			cart.error(checkout.affirmErrorMsg);
			checkout.config.affirmError = 0;
		}
		if (checkout.session.get('PayPalConfirmed') && !cart.shipping.$zip.val()) {
			cart.shipping.showValidateErrors( cart.shipping.getValidateErrors() )
		}

        totals._callTotalChangedListeners(oldValues);
		this.updateNumItems(); // update the header shopping cart badge in case quatities have changed

	};

	this.buildContent = function() {
		// do we have promotional discounts in effect?
		var promoDiscount = 0;
		for (var cartItemKey in cart.items) {
			promoDiscount += (parseFloat(cart.items[cartItemKey].data.promoDiscount) || 0) * parseInt(cart.items[cartItemKey].data.qty);
		}

		if (checkout.config.promoCodeEnabled && promoDiscount) {
			$('.js-promo-total').show();
			totals.$subtotal.html( '$' + commaSeparate(parseFloat(totals.values.subtotal) + promoDiscount) );
			totals.$cartPromotions.html( '-$' + commaSeparate(promoDiscount) );
			totals.$cartPromoSubtotal.html( '$' + commaSeparate(totals.values.subtotal) );			
		} else {
			$('.js-promo-total').hide();
			totals.$subtotal.html( '$' + commaSeparate(totals.values.subtotal) );			
		}

		if ( !cart.shipping.$zip.val() || cart.shipping.getValidateErrors().length ) {
			totals.$shipping.html( '-' );
		} else {
			if (totals.values.origShipping != totals.values.shipping && totals.values.shipping > 0) {
				totals.$shipping.html( '$' + commaSeparate(totals.values.shipping) );
			} else {
				if (parseFloat(totals.values.origShipping) > 0) {
					totals.$shipping.html( '$' + commaSeparate(totals.values.origShipping) );
				} else {
					totals.$shipping.html( '<span class="text-success">FREE</span>' );
				}
			}
		}
		
		//if ( checkout.config.isEndeca && ( !cart.shipping.$zip.val() || cart.shipping.getValidateErrors().length ) ) {
		//	totals.$shippingOverride.html( 'Calculate Above' );
		//} else {
		//	totals.$shippingOverride.html( '$' + commaSeparate(totals.values.shipping) );
		//}

		//if (totals.values.origShipping != totals.values.shipping) {
		//	totals.$shipping.css('text-decoration', 'line-through');
		//	totals.$shippingOverrideWrap.show();
		//} else {
		//	totals.$shipping.css('text-decoration', '');
		//	totals.$shippingOverrideWrap.hide();
		//}

		if ( !cart.shipping.$zip.val() || cart.shipping.getValidateErrors().length ) {
			totals.$tax.html( '-' );
		} else {
			totals.$tax.html( '$' + commaSeparate(totals.values.origTax) );
		}

		if (
			checkout.user
			&& totals.$taxExempt.prop('checked')
		)
			totals.$tax.css('text-decoration', 'line-through');
		else
			totals.$tax.css('text-decoration', '');

		if (totals.values.credits) {
			totals.$total.html( '$' + commaSeparate( (totals.values.total - totals.values.credits).toMoney() ) );
		} else {
			totals.$total.html( '$' + commaSeparate(totals.values.total) );
		}

		if (parseFloat(totals.values.origTax)) {

			totals.$taxWrap.show();

			if (checkout.user)
				totals.$taxExemptWrap.show();

		} else {
			totals.$taxWrap.hide();
			totals.$taxExemptWrap.hide();
		}

        if ( totals.values.total >= checkout.config.paypalOfferCreditAmount ) {
        	totals.$paypalExpressCreditWrapper.removeClass('hide');
            totals.showPaypalCreditMessaging( totals.values.total );
        }
        else {
            totals.hidePaypalCreditMessaging();
        	totals.$paypalExpressCreditWrapper.addClass('hide');
        }

		// update the total for affirm
		if (affirm && affirm.ui && affirm.ui.payments && affirm.ui.payments.get_estimate) {
			updateAffirmRate();
		}

		totals.buildFees();
		//totals.buildSameDayNotice();
		// totals.buildPaymentMethods();
	};

	this.buildSameDayNotice = function() {
		var cutOffTime;
		var showNotice = true;
		// check that ever item has a cutoff time and find the earliest one
		$.each(cart.items, function(i, item) {
			var itemCutoff = item.data.sameDayCutoff;
			if (itemCutoff) {
				if (!cutOffTime) {
					cutOffTime = itemCutoff;
				}
				else {
					// date is arbitrary, just comparing time
					if (Date.parse('01/01/2000 ' + cutOffTime) > Date.parse('01/01/2000 ' + itemCutoff) ) {
						cutOffTime = itemCutoff;
					}					
				}
			}
			else {
				showNotice = false;
			}
		});

		// build a pretty version of cutoff time for display
		if (showNotice && cutOffTime) {
			var timeParts = cutOffTime.split(':');
			var hour = parseInt(timeParts[0]);
			var minute = timeParts[1];
			var ampm = 'am';

			if (hour > 12) {
				hour = hour - 12;
				ampm = 'pm';
			}
			var prettyTime = hour.toString();
			if (parseInt(minute) > 0) {
				prettyTime += ':' + minute;
			}
			prettyTime += ampm;

			totals.$sameDayCutoff.html(prettyTime);
			totals.$sameDayNotice.show();
			totals.$sameDayNotice.css('display', 'block');
		}
		else {
			totals.$sameDayCutoff.html('5pm');
			totals.$sameDayNotice.hide();
		}
	};

	this.buildFees = function() {
		var fees = [];

		for (var feeLabel in totals.values.fees)
			fees.push(
				'<div class="fee">'
					+ '<'+totals.elementType+'>' + feeLabel + ' Fee: </'+totals.elementType+'>'
					+ '<span>'
						+ parseFloat(totals.values.fees[feeLabel]).toMoney()
					+ '</span>'
				+ '</div>'
			);

		totals.$wrap
			.children('.fee')
			.remove();

		if (fees.length)
			totals.$totalWrap.before(fees);

	};

	// Called by payment when the payment methods or balances arrays are set
	// Needs to update totals and fees if any
	this.buildPaymentMethodsV2 = function(activeMethods, activeBalances) {
        var $rewards = $('.js-rewards');
        var $rewardsTotal = $('.js-rewards-total');

        var $instore = $('.js-store-credit');
        var $instoreTotal = $('.js-store-credit-total');

        var $giftcards = $('.js-gift-cards');
        var $giftcardsTotal = $('.js-gift-cards-total');

        var $wirexfer = $('.js-wire-transfer');
        var $wirexferFee = $('.js-wire-transfer-fee');

        $rewards.addClass('hidden');
        $instore.addClass('hidden');
        $giftcards.addClass('hidden');
        $wirexfer.addClass('hidden');

        var data = {};
        var credits = 0;

        var siteName = checkout.config.siteNameFirstWord;
        activeBalances.forEach(function(item){
			switch (item.type) {
				case 'rewards':
					$rewards.removeClass('hidden');
					$rewardsTotal.html('-$'+item.amount.toMoney());
					data[siteName + ' Rewards'] = item.amount;
					break;
				case 'instore':
                    $instore.removeClass('hidden');
                    $instoreTotal.html('-$'+item.amount.toMoney());
                    data[siteName + ' Store Credit'] = item.amount;
					break;
				case 'giftcard':
                    $giftcards.removeClass('hidden');
                    $giftcardsTotal.html('-$'+item.amount.toMoney());
                    data['Gift Cards'] = item.amount;
					break;
			}
            credits += item.amount;
		});

        var fees = {};
        fees['Wire Transfer'] = 0;

        activeMethods.forEach(function(item){
            switch (item.method) {
                case 'wiretransfer':
                    $wirexfer.removeClass('hidden');
                    $wirexferFee.html('+$'+item.fee.toMoney());
                    fees['Wire Transfer'] = item.fee;
                    break;
            }
		});

        totals.values.balances = data;
        totals.values.credits = credits;
        totals.values.fees = fees;
        totals.update();
	};

	this.buildPaymentMethods = function() {
		var values = totals.values,
			rows = [],
			displayRemaining = parseFloat(totals.values.remaining);
		var payment = checkout.payment;
		if (isReview)
			payment = checkout.review.payment;

		if (payment) {

			$.each(payment.balanceMethods, function(i, method) {
				var balance = (parseFloat(values.balances[method.label]) || 0);

				if (balance) {
					method.$balance.text( '-$' + commaSeparate(balance.toMoney()) );
					method.$wrap.show();
				} else {
					method.$wrap.hide();
				}
			});

			payment.$methodContainer.find('.payment-method:visible')
				.each(function(i, methodWrap) {
					var method = payment.methods[$(methodWrap).data('methodKey')],
						amt = checkout.payment.getMethodAmt(method);

					displayRemaining -= amt;

					/*
					rows.push(
						'<div class="payment-summary">'
							+ '<'+totals.elementType+'>' + method.label + ': </'+totals.elementType+'>'
							+ '<span>'
								+ '-$' + commaSeparate(amt.toMoney())
							+ '</span>'
						+ '</div>'
					);
					*/

				});

		}

		totals.$wrap
			.children('.payment-summary')
			.remove();

		if (displayRemaining < 0)
			displayRemaining = 0;

		totals.$remaining.html('$' + displayRemaining.toMoney());

		if (rows.length) {
			totals.$totalWrap.after(rows.join("\n"));
			totals.$remainingWrap.show();
		} else
			totals.$remainingWrap.hide();

	};

	this.changeTaxExempt = function() {

		checkout.session.set({
			'taxExempt': (totals.$taxExempt.prop('checked') ? 1 : 0)
		});

		totals.update('payment');
	};

    var loadingStack = [];
	this.loading = function(loadingMsg, loadSuccess, stepChanged) {
        if ( loadingMsg ) {
            loadingStack.push( loadingMsg );
        }
        else {
            loadingMsg = loadingStack.shift();
        }

		if (loadingMsg) {

			cart.$wrap.trigger('loading', loadingMsg);

			$("#textcart").hide();
			totals.$loadingMsg.html(loadingMsg);
			totals.$loadingOverlay.show();
			//checkout.alignMiddle(totals.$loadingOverlay.find('.msg'), totals.$loadingOverlay);

		} else {
			if (checkout.user)
				$("#textcart").show();
			totals.$loadingOverlay.hide();

			$('body').addClass('doneLoading');

			if (loadSuccess)
				cart.$wrap.trigger('loadDone', stepChanged);
			else
				cart.$wrap.trigger('loadFail');
		}
	};

    this.showPaypalCreditMessaging = function( total ) {
        if ( totals.$paypalCreditMessaging.length == 0 ) return;

        totals.$paypalCreditMessaging.show();
        paypal.Messages( {
            'account' : checkout.config.paypalCreditMerchantID,
            'amount'  : total,
            'style'   : {
                'layout' : "flex",
                'color'  : "gray",
                'ratio'  : "8x1",
            },
        } )
        .render( totals.$paypalCreditMessaging[ 0 ] );
    };

    this.hidePaypalCreditMessaging = function() {
        totals.$paypalCreditMessaging.hide();
    };

    this.showPaypalExpressButton = function( options ) {
        if (!options) 
            options = {
                button: 'checkout'
            };
        if (!options.hasOwnProperty('button')) 
            options['button'] = 'checkout';

        var credit = (options.button == 'credit') ? true : false;

        var paymentButtonShown = credit ? 'paymentCreditButtonShown' : 'paymentButtonShown';
        if ( totals[paymentButtonShown]) 
			return;
		totals[paymentButtonShown] = true;

        var paypalExpressButton = credit ?
           totals.$paypalExpressCreditButton :
           totals.$paypalExpressButton ;
        var braintreePayPalCheckout = credit ?
           checkout.braintreePayPalCreditCheckout :
           checkout.braintreePayPalCheckout ;

        if ( paypalExpressButton.length == 0 ) return;

        paypalExpressButton.on( 'click', function(e) {
            // do nothing button, for tracking purposes
            e.preventDefault();
        });

        checkout.payment.getBT( function() {
            braintree.paypalCheckout.create( {
                'client' : checkout.payment.bt
            } )
            .then( function( paypalCheckout ) {
                braintreePayPalCheckout.renderPaypalExpressButton( paypalCheckout );
            } );
        } );
    };

	this.init();
};

